var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcasslogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 32,
    viewBox: "0 0 130 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2612159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.6357 24.0361H49.6665L46.7122 15.2437L43.7347 24.0361H40.7871L36.1641 6.95947H40.1386L42.5727 15.8673L44.785 7.28161H48.6395L50.8502 15.8673L53.2392 6.95947H57.2588L52.6357 24.0361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.3035 19.0139C67.3035 22.3308 64.8193 25.0409 61.7787 25.0409C58.7381 25.0409 56.2539 22.3308 56.2539 19.0139C56.2539 15.6969 58.7381 12.9868 61.7787 12.9868C64.8193 12.9868 67.3035 15.6969 67.3035 19.0139ZM59.7229 19.0139C59.7229 20.2521 60.6437 21.2566 61.7787 21.2566C62.9137 21.2566 63.8345 20.2521 63.8345 19.0139C63.8345 17.7757 62.9137 16.7712 61.7787 16.7712C60.6437 16.7712 59.7229 17.7757 59.7229 19.0139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.4023 19.5309V9.97119H93.1495V13.3643H96.4339V16.3735H93.1495V19.5739C93.1495 20.1506 93.5657 20.5775 94.2132 20.5775H96.2958V24.0343H94.0975C91.1136 24.0343 89.4023 22.6468 89.4023 19.5309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M121.857 21.4332V13.1751H118.856V13.7122C118.018 13.2449 117.135 12.9868 116.165 12.9868C113.032 12.9868 110.496 15.6738 110.496 18.9903C110.496 22.3068 113.034 25.0409 116.165 25.0409C117.179 25.0409 118.062 24.7375 118.901 24.2929V24.8544H122.55V21.4332H121.858H121.857ZM116.252 21.2571C115.085 21.2571 114.157 20.2528 114.157 18.9921C114.157 17.7314 115.085 16.7497 116.252 16.7497C117.42 16.7497 118.37 17.7541 118.37 18.9921C118.37 20.2301 117.422 21.2571 116.252 21.2571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M129.582 20.548V24.0349H128.69C125.439 24.0349 124.272 22.7012 124.272 19.6642V12.12H123.555V8.96729H127.979V19.7076C127.979 20.2025 128.254 20.5464 128.803 20.5464H129.58L129.582 20.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.3402 12.9868V16.367H73.8779C73.1468 16.367 72.548 16.9428 72.548 17.6719V24.0364H69.0033V16.2235H68.3086V12.9868H71.7508V13.4949C72.3942 13.0973 73.0592 12.9868 73.7456 12.9868H75.3402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M88.3979 24.0349H84.0799L81.2983 20.3006L80.6041 20.9562V24.0349H77.0346V12.12H76.3438V8.96729H80.6041V16.1355L83.616 13.2721H87.8468L83.6818 17.9642L88.3979 24.0349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M108.486 12.9868V19.7959C108.486 22.6903 106.387 25.0409 103.797 25.0409C101.208 25.0409 99.1097 22.6921 99.1097 19.7959V16.4622H98.4414V12.9868H102.524V19.7959C102.524 20.5789 103.096 21.2201 103.796 21.2201C104.496 21.2201 105.069 20.5789 105.069 19.7959V12.9868H108.485H108.486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.0451 10.979H0V21.0241H10.0451V10.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.0875 21.022V31.0671L10.0469 21.022H19.0875Z",
    fill: "#00E2A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M29.1325 6.30317V21.0223H19.5889V16.3491C19.5889 13.3827 17.3045 10.9781 14.4864 10.9781H10.0469V0.932129H24.0301C26.8482 0.932129 29.1325 3.33673 29.1325 6.30317Z",
    fill: "#00E2A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M19.0875 16.3505V21.0241L10.0469 10.979H14.2524C16.9219 10.979 19.0859 13.3838 19.0859 16.3505",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcasslogo);
export default __webpack_public_path__ + "static/media/ccasslogo.92c50ce1e0f0724bbe8bf2d517c760ca.svg";
export { ForwardRef as ReactComponent };